import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthGuard, EmailGuard } from "../App";
import { Oval } from "react-loader-spinner";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";
import { StandardURL } from "../App";

const VacatingSettlement = () => {
  const [vacatingSettlements, setVacatingSettlements] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchVacatingSettlements();
  }, []);

  const fetchVacatingSettlements = async () => {
    setIsLoading(true);
    setError(null);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${StandardURL}/iNyumba/vacatinghouse/adminviewcompleteuserssettlement`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.response && Array.isArray(response.data.response)) {
        setVacatingSettlements(response.data.response);
      } else {
        setVacatingSettlements([]);
      }
    } catch (err) {
      setError("Failed to fetch vacating settlements.");
      toast.error(err.response?.data?.response || "Failed to fetch data.");
      console.error("Error fetching vacating settlements:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCompleteSettlement = async (userIDset) => {
    if (!window.confirm("Are you sure you want to complete this settlement? This action is irreversible.")) {
      return;
    }

    const token = localStorage.getItem("token");
    setIsLoading(true);

    try {
      await axios.put(
        `${StandardURL}/iNyumba/vacatinghouse/adminupdate/${userIDset}`,
        null,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("User vacated successfully!");
      fetchVacatingSettlements();
    } catch (err) {
      console.error("Error updating Vacating Settlement:", err);
      toast.error(err.response?.data?.response || "Failed to complete settlement.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <EmailGuard>
      <AuthGuard>
        <div className="container mx-auto px-4 py-8 bg-gray-100 min-h-screen">
          <h1 className="text-3xl font-bold text-gray-800 text-center mb-6">
            Tenants Complete Vacating
          </h1>

          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            {isLoading ? (
              <div className="flex justify-center items-center p-8">
                <Oval color="#4F46E5" height={50} width={50} />
              </div>
            ) : error ? (
              <div className="text-center p-8 text-red-500 font-semibold flex items-center justify-center">
                <FaExclamationCircle className="mr-2" />
                {error}
              </div>
            ) : vacatingSettlements.length === 0 ? (
              <div className="text-center p-8 text-gray-500">
                No vacating settlements available.
              </div>
            ) : (
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      {["ID", "Property ID", "User ID", "Rental ID", "Phone", "Amount to Owner", "Service Fee", "Amount to User", "Status", "Created On", "Actions"].map(header => (
                        <th key={header} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {vacatingSettlements.map((settlement, index) => (
                      <tr key={settlement.depositsettlement_id} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{settlement.depositsettlement_id}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{settlement.property_id}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{settlement.user_id}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{settlement.rental_id}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{settlement.phonenumber}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Ksh {settlement.amounttoowner}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Ksh {settlement.servicefee}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Ksh {settlement.amounttouser}</td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm">
                          <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full
                            ${settlement.completestatus === 'Pending' ? 'bg-yellow-100 text-yellow-800' : 'bg-green-100 text-green-800'}`}>
                            {settlement.completestatus}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                          {new Date(settlement.created_at).toLocaleDateString()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                          <button
                            onClick={() => handleCompleteSettlement(settlement.user_id)}
                            className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-md text-sm transition duration-150 ease-in-out"
                          >
                            <FaCheckCircle className="inline mr-1" />
                            Complete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </AuthGuard>
    </EmailGuard>
  );
};

export default VacatingSettlement;